import { render, staticRenderFns } from "./Shopinfo.vue?vue&type=template&id=6b1cd696&scoped=true&"
import script from "./Shopinfo.vue?vue&type=script&lang=js&"
export * from "./Shopinfo.vue?vue&type=script&lang=js&"
import style0 from "./Shopinfo.vue?vue&type=style&index=0&id=6b1cd696&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1cd696",
  null
  
)

export default component.exports